import React, { Ref, useCallback, useEffect, useRef, useState } from 'react';
import { Post } from '../../../types';
import "./style.css"
import Spinner from '../../../global-components/src/components/spinner/spiner';
import { errorMessage as errorMessageFormatted } from '../../../global-components/src/utils/text';
import { useTheme } from '../../../global-components/src';
import { usePasswordCache } from '../../../hooks/usePasswordCache';
import { useTranslation } from 'react-i18next';

interface ConfirmationModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: (password: string) => void; // Aceita a senha como argumento
    post?: Post | null;
    requirePassword?: boolean;
    isLoading: boolean;
    title: string;
    idModal?: string;
    coverMobile?: boolean;
    text?: string;
    errorMessage?: string;
    setPassword: (password: string) => void; // Adicione esta propriedade
    closeRef?: Ref<HTMLButtonElement> | undefined; // Adicione esta propriedade
    extraContent?: React.ReactNode; // Nova prop para HTML opcional
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ idModal, show, onClose, onConfirm, requirePassword, title, text, setPassword, errorMessage, isLoading, closeRef, extraContent, coverMobile = true }) => {
    const [password, setLocalPassword] = useState('');
    const [errorFormmated, setErrorFormatted] = useState('');
    const [hasCachedPassword, setHasCachedPassword] = useState(false);
    const openModalRef = useRef<HTMLButtonElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement | null>(null);
    const { isDarkMode } = useTheme();
    const { savePassword, getPassword } = usePasswordCache();
    const firstRun = useRef(true);
    const { t } = useTranslation();

    // Pre-fill from cache when the modal opens (only for password modals)
    useEffect(() => {
        if (show && requirePassword) {
            const cached = getPassword();
            setHasCachedPassword(!!cached);
            if (cached) {
                setLocalPassword(cached);
                setPassword(cached);
            }
        } else {
            setHasCachedPassword(false);
        }
    }, [show, requirePassword, getPassword, setPassword]);

    const handleConfirm = useCallback(() => {
        if (requirePassword) {
            if (password) savePassword(password);
            onConfirm(password);
        } else {
            onConfirm('');
        }
    }, [requirePassword, password, onConfirm, savePassword]); 

    useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false; // ignora a primeira execução
            return;
        }
            
      if (window.ReactNativeWebView && typeof window.ReactNativeWebView.postMessage === 'function') {
        window.ReactNativeWebView.postMessage(JSON.stringify({ statusBarStyle: show ? (isDarkMode ? "#181818ff" : "#b4b4b4"): (isDarkMode ? "#000" : "#fff") }));
      }
  }, [show]);

    useEffect(() => {
        if (show)
            openModalRef.current?.click()
        else
            closeModalRef.current?.click()
    }, [show])


    return (
        <>
            {/* <div className={`modal fade`} aria-labelledby="confirmation-modal" aria-hidden="true"> */}
            {/* <div className={`modal modal-password fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', opacity: show ? '1' : '0'  }} aria-labelledby="confirmation-modal" aria-hidden="true"> */}
            <div className={"modal fade confirmation-modal"} id={idModal ? idModal : "confirmation-modal"} onClick={() => { setPassword(""); setLocalPassword(""); onClose() }} aria-hidden="true">
                <div className={`modal-dialog ${coverMobile ? "cover-mobile" : "not-cover-mobile"}`}>
                    <div id="username-suggestions"></div>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header" style={{ borderBottom: "0!important", paddingBottom: 0, }}>
                            <h5 className="modal-title" id="modal-post">{title}</h5>
                            <button ref={closeModalRef} type="button" className="btn-close svg-icons-color btn-dark" onClick={() => { setPassword(""); setLocalPassword(""); onClose() }} data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>{text}</p>
                            {requirePassword && !hasCachedPassword && (
                                <form action="">
                                    <input name="username" autoComplete="username" className="d-none"/> {/* Campo oculto para evitar remover warning */}
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => {
                                            setLocalPassword(e.target.value);
                                            setPassword(e.target.value);
                                        }}
                                        className="form-control"
                                        placeholder={t("confirmationModal.passwordPlaceholder")}
                                        autoComplete='new-password'
                                    />
                                </form>
                            )}

                            {extraContent}
                            <div className="invalid-feedback invalid-feedback-comment-text" style={{ display: "block" }}>
                                {errorMessage}
                            </div>

                            <div className="modal-footer mt-4" style={{ padding: "0" }}>
                                <div className="row" style={{width: "100%", justifyContent: "end"}}>
                                    <div className="col-6 col-md-3 col-lg-3 col-xl-3 col-add-post-btn" style={{ paddingLeft: "0px", paddingRight: "5px" }}>
                                        <button type="button" className="btn-w-100 btn btn-secondary" onClick={onClose}>{t("confirmationModal.cancel")}</button>
                                    </div>
                                    <div className="col-6 col-md-3 col-lg-3 col-xl-3 col-add-post-btn" style={{ paddingRight: "0px", paddingLeft: "5px" }}>
                                        <button disabled={isLoading} type="button" className="btn-w-100 btn btn-blue" onClick={handleConfirm}>
                                            {!isLoading ? (
                                                <>{t("confirmationModal.confirm")}</>
                                            ) : (
                                                <Spinner />
                                            )}
                                        </button>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button className="d-none" ref={openModalRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={idModal ? `#${idModal}` : "#confirmation-modal"}>a</button>

        </>

    );
};

export default ConfirmationModal;
